import Sections from './sections';
import CashbackPointsRow from './CashbackPointsRow';
import CheckoutSteps from './CheckoutSteps';
import CheckoutThreshold from './CheckoutThreshold';
import LoginBanner from './LoginBanner';
import OrderDraftErrorPage from './OrderDraftErrorPage';
import OrderInfo from './OrderInfo';
import OrderMethodInfo from './OrderMethodInfo';
import ProceedToPaymentButton from './ProceedToPaymentButton';
import PromoCodeInput from './PromoCodeInput';
import Tips from './Tips';

export default {
  Sections,
  CashbackPointsRow,
  CheckoutSteps,
  CheckoutThreshold,
  LoginBanner,
  OrderDraftErrorPage,
  OrderInfo,
  OrderMethodInfo,
  ProceedToPaymentButton,
  PromoCodeInput,
  Tips,
};
